<template>
  <router-view/>
  <div v-if="buildSha" class="build-info" :title="buildTimeIso">
    <span class="build-info__sha">{{ buildSha }}</span>
    <span class="build-info__sep">·</span>
    <span class="build-info__time">{{ buildTimeDisplay }}</span>
  </div>
</template>

<script>
import { computed, onMounted, onUnmounted } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

export default {
  setup() {
    const store = useStore();
    const router = useRouter();

    function isTokenExpired(token) {
      if (!token) return true;
      try {
        const b64url = token.split('.')[1];
        const b64 = b64url.replace(/-/g, '+').replace(/_/g, '/');
        const padded = b64 + '='.repeat((4 - (b64.length % 4)) % 4);
        const payload = JSON.parse(atob(padded));
        return payload.exp * 1000 < Date.now();
      } catch (e) {
        return true;
      }
    }

    function handleVisibilityChange() {
      if (document.visibilityState === 'visible') {
        const token = store.state.auth.token || localStorage.getItem('token');
        if (token && isTokenExpired(token)) {
          store.dispatch('auth/logout');
          router.push('/');
        }
      }
    }

    onMounted(() => {
      document.addEventListener('visibilitychange', handleVisibilityChange);
    });

    onUnmounted(() => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    });

    const buildSha = process.env.VUE_APP_BUILD_SHA || '';
    const buildTimeIso = process.env.VUE_APP_BUILD_TIME || '';
    const buildTimeDisplay = computed(() => {
      if (!buildTimeIso) return '';
      const d = new Date(buildTimeIso);
      if (Number.isNaN(d.getTime())) return buildTimeIso;
      const pad = (n) => String(n).padStart(2, '0');
      return `${d.getUTCFullYear()}-${pad(d.getUTCMonth() + 1)}-${pad(d.getUTCDate())} ${pad(d.getUTCHours())}:${pad(d.getUTCMinutes())} UTC`;
    });

    return { buildSha, buildTimeIso, buildTimeDisplay };
  }
};
</script>

<style scoped>
.build-info {
  position: fixed;
  left: 8px;
  bottom: 6px;
  z-index: 1000;
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace;
  font-size: 10px;
  line-height: 1;
  color: rgba(0, 0, 0, 0.45);
  background: rgba(255, 255, 255, 0.6);
  padding: 3px 6px;
  border-radius: 3px;
  pointer-events: none;
  user-select: none;
}
.build-info__sep {
  margin: 0 4px;
  opacity: 0.6;
}
@media (prefers-color-scheme: dark) {
  .build-info {
    color: rgba(255, 255, 255, 0.5);
    background: rgba(0, 0, 0, 0.35);
  }
}
</style>
